import { styled } from '@mui/material';

export const PageW = styled('div')`
  padding-left: 38px;
  margin-top: 88px;
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (max-width: 1023px) {
    padding: 0px 8px;
    padding-bottom: 96px;
  }
`;

export const PageSubTitle = styled('h3')``;

export const InnerW = styled('div')<{ isMobile?: boolean }>`
  display: flex;
  flex-direction: ${({ isMobile }) => (isMobile ? 'column' : 'row')};
  gap: 20px;
`;

export const InnerTitleW = styled('div')`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`;

export const PublicInfoContainer = styled('div')<{ hoveredZone?: string }>`
  width: 414px;
  min-height: 200px;
  border: ${({ hoveredZone, theme }) =>
    hoveredZone === 'public'
      ? `2px solid ${theme.palette.info.main}`
      : `1px solid ${theme.palette.primary.grey}`};
  background-color: ${({ hoveredZone }) =>
    hoveredZone === 'public' ? 'rgba(0, 0, 255, 0.1)' : 'transparent'};
  padding: 10px;
  border-radius: 4px;

  @media (max-width: 1023px) {
    width: 100%;
  }
`;

export const ActiveFieldW = styled('div')`
  opacity: 0.8;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  background-color: ${({ theme }) => theme.palette.white.main};
  padding: 8px;
  cursor: grabbing;
`;

export const IconSpan = styled('span')`
  cursor: grab;
  padding: 0 8px;
  font-size: 30px;
`;

export const FieldContainer = styled('div')<{
  custom?: boolean;
  transition: string | undefined;
}>`
  height: 50px;
  transition: ${({ transition }) => transition};
  padding: 8px;
  margin: 4px 0;
  background-color: ${({ custom, theme }) =>
    custom ? theme.palette.info.p030 : theme.palette.info.p020};
  border: ${({ theme }) => `1px solid ${theme.palette.primary.grey}`};
  border-radius: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const FieldInput = styled('input')`
  flex: 1;
  padding: 4px;
  border: 1px solid ${({ theme }) => theme.palette.primary.grey};
  border-radius: 4px;
  font-family: Outfit, sans-serif;
  font-size: 1rem;
`;

export const SpinnerW = styled('div')`
  cursor: not-allowed;
  position: relative;
  width: 100%;
  height: 100%;
`;

export const LabelText = styled('span')`
  flex-grow: 1;
  -webkit-user-select: none;
  user-select: none;
`;

export const NonDraggable = styled('div')`
  pointer-events: none;
`;

export const PageTitle = styled('h2')`
  font-size: 20px;
  margin: 0;
  white-space: nowrap;
  margin: 16px 0px;
`;

export const ContentW = styled('div')`
  width: 1065px;

  @media (max-width: 1280px) and (min-width: 1024px) {
    width: calc(100% - 38px);
  }

  @media (max-width: 1023px) {
    width: 100%;
  }

  @media (min-width: 1920px) {
    margin: 0 auto;
  }
`;
